import { useQuery } from "react-query";
import { request } from "../../../config/helpers/axios-instance";

const GetPrx = (orderId, isQuotation = false) => {
    let url = `userOrder/admin/orderDetails/${orderId}`;
    if (isQuotation) {
        url = `quotation/admin/orderDetails/${orderId}`;
    }
    return useQuery(
        ["get-prx", orderId],
        () =>
            request({
                url: url,
                method: "GET",
            }),
        {
            enabled: !!orderId,
        }
    );
};

export default GetPrx;
